import * as satisfactionsLib from '../api/satisfactions';
import * as updatesLib from '../api/updates';
import { fetchLoadable } from '../fetchLoadable';
import * as actionTypes from './actionTypes';
export const getUpdates = (id, casualConsistency) => fetchLoadable(actionTypes.FETCH_CASE_UPDATES, updatesLib.getByReferenceId, {
    id,
    casualConsistency,
});
export const getSatisfactions = (id) => fetchLoadable(actionTypes.FETCH_CASE_SATISFACTIONS, satisfactionsLib.get, {
    id,
});
//# sourceMappingURL=actions.js.map